import { Box, Paper, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { TipsOutline } from '@uplift/icons';

export const ProviderSummaryCard = () => {
  const { classes } = useProviderSummaryCardStyles();

  return (
    <Paper elevation={0} className={classes.root}>
      <Box className={classes.iconContainer}>
        <TipsOutline fontSize="small" />
      </Box>
      <Typography variant="body1" className={classes.text}>
        We have 900+ providers and we’re constantly growing our provider directory.
      </Typography>
    </Paper>
  );
};

const useProviderSummaryCardStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    borderRadius: 24,
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.background.paper,
  },
  iconContainer: {
    width: 32,
    height: 32,
    position: 'absolute',
    top: '-16px',
    left: '50%',
    transform: 'translateX(-50%)',
    backgroundColor: theme.palette.info.background,
    color: theme.palette.primary.main,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(2),
  },
  text: {
    textAlign: 'center',
  },
}));
